import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Loader } from "components/Common/Loader";
import Render from "components/Common/Render";
import ActivateOfferAddCardForm from "components/Home/ActivateOfferAddCardForm";
import { useAppSelector } from "hooks/useRedux";
import { http } from "middleware/apiMiddleware";
import { useCallback, useEffect, useState } from "react";
import { RootState } from "store";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY || "");

const ActivateOfferModal = ({
  activateOfferModal,
  onSuccess,
  setErrorMessage,
  onClose
}: {
  onSuccess: () => void;
  activateOfferModal: ActivateOfferModalType;
  setErrorMessage: (message:string) => void;
  onClose:() => void
}) => {
  const [clientSecret, setClientSecret] = useState("");
  const [isCreatingIntent, setIsCreatingIntent] = useState(false);
  const [error, setError] = useState("");
  const selectedBusiness = useAppSelector(
    (state: RootState) => state.businesses.business
  );

  const fetchClientSecret = useCallback(async () => {
    try {
      setIsCreatingIntent(true);
      setError("");
      // Create card setup intent
      const { data, error } = await http.patch(
        `/business/${selectedBusiness?.uuid}/business-paid-modules/${activateOfferModal?.moduleId}`,
        {
          enabled: true,
          formData: {
            autoTopUpAmount: activateOfferModal?.topupAmount,
            referralCode: activateOfferModal?.referralCode,
          },
        }
      );
      if(!data && !!error && error?.status == 400){ 
        setErrorMessage(error?.formData[0] || 'Something went wrong');
        onClose();
      }
      if (!!data && !error) setClientSecret(data?.setupIntentClientSecret);
    } catch (error) {
      console.error("error activating stripe module", error);
      setError(
        "Unexpected Error occurred while activating module, Please contact the app admin"
      );
    } finally {
      setIsCreatingIntent(false);
    }
  }, []);

  useEffect(() => {
    fetchClientSecret();
  }, []);

  return (
    <div className="w-full">
      <Render when={!isCreatingIntent && !!error}>
        <div className={"text-failed flex justify-center item-center w-full"}>
          {error}
        </div>
      </Render>
      {isCreatingIntent ? (
        <div className="flex justify-center item-center w-full">
          <Loader />
        </div>
      ) : (
        <Render when={!!clientSecret}>
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <ActivateOfferAddCardForm
              clientSecret={clientSecret}
              onSuccess={() => {
                onSuccess && onSuccess();
              }}
              selectedBusiness={selectedBusiness}
            />
          </Elements>
        </Render>
      )}
    </div>
  );
};

export default ActivateOfferModal;
